import React from 'react'
import { makeStyles } from '@material-ui/styles'
import VerticalHandicapIconList from 'components/molecules/VerticalHandicapIconList'
import { Link, Button } from '@material-ui/core'
import pictoLogoLink from 'assets/images/pictoaccess-logo.png'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
  },
  informations: {
    flex: '1 0 auto',
  },
  pictoLogo: {
    width: theme.spacing(13),
  },
  otherLogo: {
    width: theme.spacing(13),
    height: theme.spacing(13),
    objectFit: 'contain',
    textAlign: 'center',
  },
  alignContent: {
    textAlign: 'center',
    marginTop: theme.spacing(3),
  },
  displayPicture: {
    textAlign: 'center',
    height: theme.spacing(13),
    marginBottom: theme.spacing(5),
  },
}))

const VerticalWidgetPage = (props) => {
  const { handicaps, cardUrl, picture } = props
  const classes = useStyles()

  return (
    <div 
      tabIndex="-1" 
      onClick={() => window.open(cardUrl)} 
      className={classes.root}
    >
      <div className={classes.displayPicture}>
        <img
          src={picture && `https://${picture}`}
          className={classes.otherLogo}
          alt=""
        />
      </div>
      <div className={classes.informations}>
        <VerticalHandicapIconList handicaps={handicaps} />
        <div className={classes.alignContent}>
          <Button
            target="_blank"
            href={cardUrl}
            color="primary"
            variant="contained"
          >
            Consulter l'accessibilité
          </Button>
        </div>
        <div className={classes.alignContent}>
          <Link href={cardUrl} target="_blank">
            <img
              src={pictoLogoLink}
              className={classes.pictoLogo}
              alt="PictoAccess"
            />
          </Link>
        </div>
      </div>
    </div>
  )
}

export default VerticalWidgetPage
